<script lang="ts">
import { computed, defineComponent } from 'vue'

const ICONS = import.meta.glob('../../assets/svg/*.svg', { eager: true })

export default defineComponent({
  name: 'AsyncIcon',
  props: {
    name: { type: String, required: true }
  },
  setup (props) {
    const icon = computed(() => ICONS[`../../assets/svg/${props.name}.svg`])

    const classLogo = computed(() => {
      return props.name === 'logo' ? 'icon-logo' : 'icon'
    })

    return {
      icon,
      classLogo
    }
  }
})
</script>

<template>
  <component
    :is="icon"
    v-if="icon"
    :key="icon"
    aria-hidden="true"
    :class="classLogo"
    focusable="false"
  />
</template>

<style lang="scss" scoped>
.icon {
  width: 1em;
  height: 1em;
}

.icon-logo {
  top: 0;

  // max-height: rem(200px);
  // font-size: rem(250px);
}
</style>
